<template>
  <div class="tab-box">
    <div class="tab-item" :class="{active: currentIndex == 1}" @click="tabSwitch(1)">提现配置</div>
    <div class="tab-item" :class="{active: currentIndex == 2}" @click="tabSwitch(2)">入网签约配置</div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  computed: {
    currentIndex: {
      get() {
        return this.type
      },
      set(newVal) {
        this.$emit('update:type', newVal)
      }
    }
  },
  methods: {
    tabSwitch(index) {
      this.currentIndex = index
      this.$emit('tabSwitch',index)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tab-box {
    display: flex;
    align-items: center;
    width: 375px;
    height: 48px;
    padding: 0 9px;
    box-sizing: border-box;
    background: #FFECEA;
    .tab-item {
      width: 183px;
      height: 33px;
      color: #F25B41;
      text-align: center;
      line-height : 33px;
      border-radius: 6px;
    }
    .active {
      color: #fff;
      background: #FF6B59;
    }
  }
</style>